import { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

type SEOKeywordChipsInputProps = {
  label: string;
  value: string;
  helperText?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
};

function parseKeywords(value: string): string[] {
  return value.split(",").map((keyword) => keyword.trim()).filter(Boolean);
}

export default function SEOKeywordChipsInput({
  label,
  value,
  helperText,
  disabled = false,
  onChange,
}: SEOKeywordChipsInputProps) {
  const [inputValue, setInputValue] = useState("");
  const keywords = parseKeywords(value);

  const commitInput = () => {
    const pending = parseKeywords(inputValue);
    if (pending.length) {
      const next = [...keywords];
      pending.forEach((keyword) => {
        if (!next.includes(keyword)) next.push(keyword);
      });
      onChange(next.join(", "));
    }
    setInputValue("");
  };

  return (
    <Autocomplete<string, true, false, true>
      multiple
      freeSolo
      options={[]}
      disabled={disabled}
      value={keywords}
      inputValue={inputValue}
      onInputChange={(_event, nextInput, reason) => {
        if (reason === "input" || reason === "clear") setInputValue(nextInput);
      }}
      onChange={(_event, nextKeywords) => {
        const normalized = nextKeywords.map((item) => item.trim()).filter(Boolean);
        onChange(Array.from(new Set(normalized)).join(", "));
        setInputValue("");
      }}
      onKeyDown={(event) => {
        if (event.key === ",") {
          event.preventDefault();
          commitInput();
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} helperText={helperText} />
      )}
    />
  );
}
